<template lang="pug">
nav.navbar.is-fixed-top.is-white(role="navigation" aria-label="main navigation" :lang="language" v-if="!hideNavbar")
	.navbar-container
		.navbar-brand
			router-link.navbar-item(:to="urlHome")
				img.navbar-icon(src="/icon.png")
				img.navbar-logo(v-if="language === 'it'" src="/logo_ita.svg")
				img.navbar-logo(v-else-if="language === 'es'" src="/logo_esp.svg")
				img.navbar-logo(v-else src="/logo_eng.svg")

			a.navbar-burger.burger(role="button" aria-label="menu" aria-expanded="false" @click="toggleNavbar" v-bind:class="navbarClass")
				span(aria-hidden="true")
				span(aria-hidden="true")
				span(aria-hidden="true")
		#navbar.navbar-menu(v-bind:class="navbarClass")
			.navbar-end
				router-link.navbar-item(:to="urlHome")
					span {{ $t("menu.home") }}
				router-link.navbar-item(:to="urlLogin" v-if="!accessToken")
					span {{ $t("menu.login") }}
				.navbar-item.has-dropdown.is-hoverable(v-if="tokenType === 'company'")
					a.navbar-link {{ $t("menu.panel") }}

					.navbar-dropdown
						router-link.navbar-item(:to="'/' + $route.params.language + '/panel/invite-codes'")
							span {{ $t("menu.codes") }}
						router-link.navbar-item(:to="'/' + $route.params.language + '/panel/fitness-league'")
							span {{ $t("menu.ranking") }}
						router-link.navbar-item(:to="'/' + $route.params.language + '/panel/analytics'")
							span {{ $t("menu.analytics") }}
						router-link.navbar-item(:to="'/' + $route.params.language + '/panel/ticket'")
							span {{ $t("menu.tickets") }}
						router-link.navbar-item(:to="'/' + $route.params.language + '/panel/password'")
							span {{ $t("menu.password") }}

				router-link.navbar-item(:to="urlPromoCode" v-if="$route.name === 'promo'")
					span {{ $t("menu.promo_code") }}

				form.navbar-item(
					method="POST"
					target="_blank"
					action="/api/user/customer-portal"
					v-if="accessToken && userState && userState.subscriptionPanelActive"
				)
					input(type="hidden" name="token" :value="accessToken")
					button.span(type="submit")
						span {{ $t("menu.subscription") }}

				router-link.navbar-item(:to="urlProfile" v-if="accessToken && userState && userState.subscriptionPanelActive")
					span {{ $t("menu.profile") }}
				router-link.navbar-item(:to="urlProfile" v-else-if="tokenType === 'user'")
					span {{ $t("menu.subscription") }}
				router-link.navbar-item(:to="urlAccount" v-if="accessToken && tokenType === 'user'")
					span {{ $t("menu.authmanage") }}

				a.navbar-item(@click="logout" v-if="accessToken")
					span {{ $t("menu.logout") }}

				router-link.navbar-item(:to="urlPromoCode" v-else-if="$route.name !== 'promo'")
					span {{ $t("menu.promo_code") }}

				//-v-else-if="$route.name == 'home-enel'"
				//-template(v-else-if="$route.name !== 'promo'")
					promo-codes

					router-link.navbar-item(:to="urlPromoCode")
						span {{ $t("menu.promo_code") }}
.minimal-navbar(v-else)
	.columns.is-centered.is-mobile
		.column.is-narrow
			router-link(:to="urlHome")
				img.navbar-logo(v-if="language === 'it'" src="/logo_ita.svg")
				img.navbar-logo(v-else-if="language === 'es'" src="/logo_esp.svg")
				img.navbar-logo(v-else src="/logo_eng.svg")
</template>

<script>
import { setTimeout } from 'timers';
import PromoCodes from './navbar/PromoCodes.vue'

export default {
	components: {
		PromoCodes
	},
	data() {
		return {
			active           : false,
			tickingScroll    : false,
			hideNavbar       : false,
			newScrollPosition: 0,
			bottomBarSection : null
		}
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		tokenType() {
			return this.$store.state.auth.accessToken ? (this.$store.state.auth.tokenType || 'user') : null
		},
		userState() {
			return this.$store.state.user.userState
		},
		navbarClass() {
			return { 'is-active': this.active, 'is-landing': this.$route.name === 'landing' }
		},
		language() {
			return this.$t('locale.lang')
		},
		itClass() {
			return { 'is-active': this.$t('locale.lang') === 'it' }
		},
		enClass() {
			return { 'is-active': this.$t('locale.lang') === 'en' }
		},
		esClass() {
			return { 'is-active': this.$t('locale.lang') === 'es' }
		},
		urlHome() {
			if (this.$route.name === 'home-enel') {
				return '/' + this.$route.params.language + '/test-enel'
			}
			return '/' + this.$route.params.language
		},
		urlLogin() {
			return '/' + this.$route.params.language + '/login'
		},
		urlProfile() {
			return '/' + this.$route.params.language + '/profile'
		},
		urlAccount() {
			return '/' + this.$route.params.language + '/account-auth'
		},
		urlPromoCode() {
			return '/' + this.$route.params.language + '/promo-code'
		}
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll)
		this.newScrollPosition = window.scrollY
		if (!this.setScrollClass(this.newScrollPosition)) {
			document.documentElement.classList.remove('is-scrolled-top')
		}

		this.bottomBarSection = document.querySelector('.bottom-bar-section')
		this.prepareRoute(this.$route, this.userState)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll)
	},
	methods: {
		toggleNavbar(ev) {
			this.active = !this.active
		},
		logout() {
			this.$store.dispatch('auth/logout')
				.then(() => {
					this.$store.commit('user/SET_USER_AUTH', null)
					this.$store.commit('user/SET_AUTH_RESTORE_PASSWORD', false)

					this.$router.replace('/' + this.$route.params.language)
				})
				.catch(err => {
					console.warn(err.message)
				})
		},
		isInViewport(elem) {
			if (!elem) return false
			const bounding = elem.getBoundingClientRect();
			return (
				bounding.top >= 0 &&
				bounding.left >= 0 &&
				bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
			)
		},
		setScrollClass(scrollPos) {
			const hasPageHeader = document.getElementsByTagName("BODY")[0].classList.contains('page-header')
			if (hasPageHeader) {
				if (scrollPos < 50) {
					document.documentElement.classList.add('is-scrolled-top')
				} else {
					document.documentElement.classList.remove('is-scrolled-top')
				}
				return true
			}

			return false
		},
		onScroll(ev) {
			this.newScrollPosition = window.scrollY
			if (!this.tickingScroll) {
				window.requestAnimationFrame(() => {
					this.setScrollClass(this.newScrollPosition)
					this.tickingScroll = false;
				});

				this.tickingScroll = true;
			}
		},
		goHome() {
			this.$store.commit('user/SET_USER_PROMO_CODE', null)
			this.$router.push('/' + this.$route.params.language)
		},
		goSignup() {
			this.$router.push('/' + this.$route.params.language + '/signup')
		},
		prepareRoute(to, userState) {
			if (to.meta.hideNavbar) {
				this.hideNavbar = true
			} else if (to.meta.hideNavbarIfPayment) {
				if (userState && userState.has_subscription && (userState.trial_active || userState.subscription_active)) {
					this.hideNavbar = false
				} else if (userState && userState.subscription_active && userState.voucher_active) {
					this.hideNavbar = false
				} else if (userState && userState.expired_subscription) {
					this.hideNavbar = false
				} else {
					this.hideNavbar = true
				}
			} else {
				this.hideNavbar = false
			}

			if (this.hideNavbar) {
				document.documentElement.classList.remove('is-scrolled-top')
				return
			}

			if (to.name === 'profile') {
				document.getElementsByTagName("BODY")[0].classList.add('page-header')
			}

			document.documentElement.classList.add('is-scrolled-top')
			this.tickingScroll = true
			this.active = false
			setTimeout(() => {
				this.newScrollPosition = window.scrollY
				this.setScrollClass(this.newScrollPosition)
				this.bottomBarSection = document.querySelector('.bottom-bar-section')
				this.tickingScroll = false
			}, 600)
		}
	},
	watch: {
		'$route' (to, from) {
			this.prepareRoute(to, this.userState)
		},
		userState (to, from) {
			this.prepareRoute(this.$route, to)
		}
  	}
}
</script>
